import React, { Component } from "react";
import {
  Layout,
  Input,
  Button,
  message,
  notification,
  Row,
  Col,
  Checkbox
} from "antd";
import { NavLink } from "react-router-dom";
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, LockOutlined, MailOutlined, TikTokOutlined, UserOutlined, WhatsAppOutlined, XOutlined, YoutubeOutlined } from "@ant-design/icons";
import logoB from "../../../assets/Biwo_bienvenida.png";
import logoGrande from "../../../assets/Biwo logo grande.png";
import bienvenidaLogin from "../../../assets/Bienvenida-Banner-Biwo.png";
import { connect } from "react-redux";
import { signup } from "../../../store/actions/user";
import { FormItem, Form, ButtonItem } from "../../../Components/Items";
import axios from "axios";

const urlContent = process.env.NODE_ENV === "development" ? `http://192.168.100.83:3000` : "https://biwo.online";

const { Content } = Layout;

class Registro extends Component {
  state = {
    loading: false,
    imagenUrl: `${urlContent}/public/login/Bienvenida-Banner-Biwo.png`,
    textoGlass: "",
    mostrarCard: true,
  };

  componentDidMount() {
    const defaultImage = `${urlContent}/public/login/Bienvenida-Banner-Biwo.png`;

    axios.post("apariencia/obtenerConfiguracionLoginPublico", {})
      .then((res) => {
        const config = res.data;
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          textoGlass: config.textoGlass || "",
          mostrarCard: config.mostrarGlass !== false,
        });
      })
      .catch(() => {
        this.setState({
          imagenUrl: defaultImage + "?t=" + Date.now(),
          mostrarCard: true,
        });
      });
  }

  onFinish(values) {
    if (!values.terminos) return message.error("Acepta los términos para continuar");
    this.setState({ loading: true });
    if (values.password === values.confirmarcontraseña) {
      this.props
        .signup(values)
        .then((data) => {
          this.setState({ loading: false });
          if (data?.success === 1) {
            message.info("Bienvenido " + data.nombre);
            this.props.history.push("/panelPrincipal");
          } else {
            message.warning(data.err);
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          notification.error({
            message: "Error inesperado",
            description: err.toString(),
            duration: 2.0,
          });
        });
    } else {
      this.setState({ loading: false });
      message.error("Las contraseñas no coinciden");
    }
  }

  onFinishFailed(e) {
    message.error("Revisa que los datos sean correctos");
  }

  render() {
    //const current = this.props.history.location.pathname;
    return (
      <Layout id="login-layout">
        <Content>
          <Row id="login-row">

            {/* Imagen */}
            <Col xs={0} sm={0} lg={13} xl={13} id="login-col-imagen">
              <div id="login-imagen-card">
                <img
                  src={this.state.imagenUrl}
                  alt="Biwo"
                  id="login-imagen"
                  onError={(e) => { e.target.src = bienvenidaLogin; }}
                />
                {this.state.mostrarCard && (
                  <div className="login-glass-card">
                    {this.state.textoGlass ? (
                      <p
                        className="login-glass-text"
                        dangerouslySetInnerHTML={{ __html: this.state.textoGlass }}
                      />
                    ) : (
                      <p className="login-glass-text">
                        Transforma cada desafío en una{" "} oportunidad con nuestro <span className="login-glass-highlight">ERP</span> : organiza, optimiza y avanza hacia el éxito con
                        confianza
                      </p>
                    )}
                  </div>
                )}
              </div>
            </Col>

            {/* Formulario */}
            <Col xs={24} sm={24} lg={11} xl={11} id="login-col-form">
              <div className="login-form-container">

                <div className="login-header-section">
                  <img src={logoB} alt="Biwo" className="login-logo-desktop" style={{ width: '30.0rem', marginLeft: '-1.5rem', marginTop: '-4rem', marginBottom: '-2.2rem', alignSelf: 'center' }} />
                  <img src={logoGrande} alt="Biwo" className="login-logo-mobile" />
                </div>

                <Form
                  defaultBehavior
                  name="registro"
                  onFinish={this.onFinish.bind(this)}
                  onFinishFailed={this.onFinishFailed}
                >
                  <FormItem>
                    <Input.Group compact>
                      <FormItem name="nombre" noStyle pattern required max={100}>
                        <Input
                          style={{ width: "33%" }}
                          placeholder="Nombre"
                          prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                          size="large"
                          maxLength={100}
                        />
                      </FormItem>
                      <FormItem name="apellidoPaterno" noStyle pattern required maxLength={50}>
                        <Input
                          style={{ width: "33%" }}
                          placeholder="Apellido P."
                          size="large"
                          maxLength={50}
                        />
                      </FormItem>
                      <FormItem name="apellidoMaterno" noStyle pattern required maxLength={50}>
                        <Input
                          style={{ width: "34%" }}
                          placeholder="Apellido M."
                          size="large"
                          maxLength={50}
                        />
                      </FormItem>
                    </Input.Group>
                  </FormItem>
                  <FormItem name="nombreUsuario" pattern required max={50} min={5}>
                    <Input
                      prefix={<UserOutlined style={{ color: "#94a3b8" }} />}
                      placeholder="Nombre de usuario"
                      size="large"
                      maxLength={50}
                    />
                  </FormItem>
                  <FormItem name="correo" pattern required max={100} email>
                    <Input
                      prefix={<MailOutlined style={{ color: "#94a3b8" }} />}
                      placeholder="Correo"
                      size="large"
                      maxLength={100}
                    />
                  </FormItem>
                  <FormItem name="password" pattern required max={50} min={5}>
                    <Input.Password
                      prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                      placeholder="Contraseña"
                      size="large"
                      maxLength={50}
                    />
                  </FormItem>
                  <FormItem name="confirmarcontraseña" pattern required max={50} min={5}>
                    <Input.Password
                      prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
                      placeholder="Confirmar Contraseña"
                      size="large"
                      maxLength={50}
                    />
                  </FormItem>
                  <FormItem name="terminos" valuePropName="checked" required>
                    <Checkbox style={{ marginLeft: '2px', fontSize: '12px' }}>
                      Acepto los
                      <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer"> Términos y Condiciones</a>,
                      <a href="/avisoDePrivacidad" target="_blank" rel="noopener noreferrer"> Aviso de Privacidad</a>,
                      <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer"> Política de Cancelación y Devolución</a>, y las
                      <a href="/condicionesServicioWhatsApp" target="_blank" rel="noopener noreferrer"> Condiciones del Servicio de WhatsApp</a>.
                    </Checkbox>
                  </FormItem>
                  <FormItem style={{ marginTop: "0", marginBottom: "4px" }}>
                    <ButtonItem htmlType="submit" type="primary" cyan
                      style={{
                        height: "44px",
                        width: "100%",
                        fontSize: "18px",
                        fontWeight: "600",
                      }}
                    >
                      Registrarse
                    </ButtonItem>
                  </FormItem>
                  <FormItem>
                    <Row
                      type="flex"
                      justify="center"
                      align="middle"
                      style={{ width: "100%", textAlign: "center", marginTop: "8px" }}
                    >
                      <h3 style={{ margin: 0, fontWeight: 400, fontSize: "14px", color: "#555" }}>¿Ya tienes cuenta?</h3>
                      <Button type="link" style={{ padding: "0 4px" }}>
                        <NavLink to="/login" style={{ color: "#00BFD6", fontWeight: 800 }}>Inicia sesión</NavLink>
                      </Button>
                    </Row>
                  </FormItem>
                </Form>

                <hr className="login-divider" />

                <div className="login-social-row">
                  <a href="https://www.facebook.com/biwoerp" target="_blank" rel="noopener noreferrer">
                    <FacebookOutlined style={{ fontSize: "18px", color: "#3b5998" }} />
                  </a>
                  <a href="https://www.instagram.com/biwo_erp" target="_blank" rel="noopener noreferrer">
                    <InstagramOutlined style={{ fontSize: "18px", color: "#e1306c" }} />
                  </a>
                  <a href="https://www.linkedin.com/company/erp-biwo" target="_blank" rel="noopener noreferrer">
                    <LinkedinOutlined style={{ fontSize: "18px", color: "#0077b5" }} />
                  </a>
                  <a href="https://x.com/ERP_BIWO" target="_blank" rel="noopener noreferrer">
                    <XOutlined style={{ fontSize: "18px", color: "#000" }} />
                  </a>
                  <a href="https://www.tiktok.com/@biwo_erp" target="_blank" rel="noopener noreferrer">
                    <TikTokOutlined style={{ fontSize: "18px", color: "#000" }} />
                  </a>
                  <a href="https://wa.me/524448923732" target="_blank" rel="noopener noreferrer">
                    <WhatsAppOutlined style={{ fontSize: "18px", color: "#25D366" }} />
                  </a>
                  <a href="https://www.youtube.com/@BiwoERP" target="_blank" rel="noopener noreferrer">
                    <YoutubeOutlined style={{ fontSize: "18px", color: "#FF0000" }} />
                  </a>
                </div>

                <div className="login-legal">
                  <p>
                    Consulta los{" "}
                    <a href="/terminosYCondiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>,{" "}
                    <a href="/avisoDePrivacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>,{" "}
                    <a href="/politicaCancelacion" target="_blank" rel="noopener noreferrer">Política de Cancelación y Devolución</a>, y las{" "}
                    <a href="/condicionesServicioWhatsApp" target="_blank" rel="noopener noreferrer">Condiciones del Servicio de WhatsApp</a>.
                  </p>
                </div>

                <p className="login-footer">Biwo ©2026</p>
              </div>
            </Col>

          </Row>
        </Content>
      </Layout>
    );
  }
}

export default connect(null, { signup })(Registro);
